import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["icon", "label", "trailingIcon"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { MenuItem as MuiMenuItem } from "@mui/material";
import { Icon, Typography } from "componentLibrary";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MenuItemWithIcon = function MenuItemWithIcon(_ref) {
  var icon = _ref.icon,
    label = _ref.label,
    trailingIcon = _ref.trailingIcon,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(MuiMenuItem, _objectSpread(_objectSpread({
    style: {
      padding: "8px 16px"
    }
  }, props), {}, {
    children: /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        alignItems: "center",
        gap: 12,
        justifyContent: trailingIcon ? "space-between" : "flex-start",
        width: trailingIcon ? "100%" : "auto"
      },
      children: [icon && /*#__PURE__*/_jsx(Icon, {
        fontSize: 16,
        className: icon
      }), /*#__PURE__*/_jsx(Typography, {
        noWrap: true,
        variant: "paragraph_small",
        weight: "medium",
        children: label
      }), trailingIcon && /*#__PURE__*/_jsx(Icon, {
        fontSize: 16,
        className: trailingIcon
      })]
    })
  }));
};
export default MenuItemWithIcon;